<app-base-action-modal
  [modalTitle]="modalTitle$ | async"
  primaryLabel="Save"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (closeClicked)="cancel()"
  (secondaryClicked)="cancel()"
  (primaryClicked)="savePaymentDetails()">
  <ng-container *ngIf="form$ | async as form" [formGroup]="form">
    <div class="d-flex flex-column gap-4">
      <div class="d-flex flex-column gap-3">
        <div *ngIf="isEditingScheduled$ | async" class="modal-description" i18n>
          This payment hasn't become effective yet. You can change the start date and amount.
        </div>
        <div *ngIf="annualPaymentHasOccurred$ | async" class="modal-description" i18n>
          An annual payment has already been received for the current year. The next annual payment cannot occur again
          until the next calendar year.
        </div>
        <div class="form-grid">
          <div class="d-flex flex-column gap-2">
            <label class="form-input-label" [for]="'paymentStartMonth'" i18n>Payment Start Month</label>
            <app-dropdown-input
              controlId="paymentStartMonth"
              formControlName="paymentStartMonth"
              [dropdowns]="monthDropdowns"
              [placeholder]="''"
              [error]="formSubmitted && form?.controls?.paymentStartMonth?.invalid" />
            <div *ngIf="!formSubmitted || form?.controls?.paymentStartMonth?.valid" class="form-input-hint" i18n>
              Payments occur by the 20th of each month
            </div>
            <app-form-error
              *ngIf="formSubmitted && form?.controls?.paymentStartMonth?.invalid"
              [errors]="form?.controls?.paymentStartMonth?.errors"
              [customErrorMessages]="customErrorMessages.paymentStartMonth" />
          </div>
          <div class="d-flex flex-column gap-2">
            <label class="form-input-label" [for]="'paymentStartYear'" i18n>Payment Year</label>
            <app-dropdown-input
              controlId="paymentStartYear"
              formControlName="paymentStartYear"
              [dropdowns]="yearDropdowns$ | async"
              [placeholder]="''"
              [error]="formSubmitted && form?.controls?.paymentStartYear?.invalid" />
            <div *ngIf="!formSubmitted || form?.controls?.paymentStartYear?.valid" class="form-input-hint" i18n>
              Select the year the payment begins.
            </div>
            <app-form-error
              *ngIf="formSubmitted && form?.controls?.paymentStartYear?.invalid"
              [errors]="form?.controls?.paymentStartYear?.errors"
              [customErrorMessages]="customErrorMessages.paymentStartYear" />
          </div>
        </div>
        <hr class="m-0" />
        <app-system-banner [banner]="banner" />
      </div>
      <div class="form-grid">
        <div class="d-flex flex-column gap-2">
          <label class="form-input-label" [for]="'paymentAmount'" i18n>Payment Amount</label>
          <app-currency-input controlId="paymentAmount" formControlName="paymentAmount" placeholder="0.00" />
          <app-form-error
            *ngIf="formSubmitted && form?.controls?.paymentAmount?.invalid"
            [errors]="form?.controls?.paymentAmount?.errors"
            [customErrorMessages]="customErrorMessages.paymentAmount" />
        </div>
      </div>
      <div class="radio-button-grid">
        <app-radio-button-input
          name="recurringPaymentAmountType"
          formControlName="recurringPaymentAmountType"
          controlId="custom"
          [value]="RecurringPaymentAmountTypeEnum.Custom" />
        <app-form-option-label labelFor="custom" i18n>Custom payment amount</app-form-option-label>
      </div>
      <ng-container *ngIf="!(minimumAlreadyInUse$ | async)">
        <ng-container *ngIf="!(isLoading$ | async); else loading">
          <div class="radio-button-grid">
            <app-radio-button-input
              name="recurringPaymentAmountType"
              formControlName="recurringPaymentAmountType"
              controlId="minimum"
              [value]="RecurringPaymentAmountTypeEnum.Minimum" />
            <app-form-option-label labelFor="minimum" i18n>
              {{ (radioButtonLabels$ | async)?.[RecurringPaymentAmountTypeEnum.Minimum]}}
            </app-form-option-label>
            <div class="radio-button-hint" i18n>
              If selected, the actual amount may vary to reflect the account's real values.
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</app-base-action-modal>

<ng-template #loading>
  <div class="radio-button-grid">
    <lib-loading-shimmer [width]="'1.5rem'" [height]="'1.5rem'" [shape]="'circle'" />
    <lib-loading-shimmer [width]="'20rem'" [height]="'1.5rem'" />
  </div>
</ng-template>
